import { css } from 'lit';

export default css`
    .about {
        color: var(--color-text-secondary);
        background-color: var(--color-surface-primary);
        border-radius: var(--metrics-radius-s);
        padding: var(--metrics-spacing-m);
    }

    .skeleton-line {
        margin-bottom: var(--metrics-spacing-s);
    }

    .skeleton-line:last-child {
        margin-bottom: 0;
    }

    .about-body {
        font-size: var(--font-size-body-m);
    }

    .about-head {
        display: flex;
        justify-content: space-between;
        margin-bottom: var(--metrics-spacing-s);
        font-size: var(--font-size-head-s);
        color: var(--color-surface-contrast);
        font-weight: var(--font-weight-head-s);
    }
`;
